// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
/**
 * ValidNumberStatus indicates if a number is valid and textable.
 */
export var ValidNumberStatus;
(function (ValidNumberStatus) {
    ValidNumberStatus["VALID_NUMBER_STATUS_UNSPECIFIED"] = "VALID_NUMBER_STATUS_UNSPECIFIED";
    ValidNumberStatus["VALID_NUMBER_STATUS_INVALID"] = "VALID_NUMBER_STATUS_INVALID";
    ValidNumberStatus["VALID_NUMBER_STATUS_VALID"] = "VALID_NUMBER_STATUS_VALID";
})(ValidNumberStatus || (ValidNumberStatus = {}));
export var ValidNumberStatus_index;
(function (ValidNumberStatus_index) {
    ValidNumberStatus_index[ValidNumberStatus_index["VALID_NUMBER_STATUS_UNSPECIFIED"] = 0] = "VALID_NUMBER_STATUS_UNSPECIFIED";
    ValidNumberStatus_index[ValidNumberStatus_index["VALID_NUMBER_STATUS_INVALID"] = 1] = "VALID_NUMBER_STATUS_INVALID";
    ValidNumberStatus_index[ValidNumberStatus_index["VALID_NUMBER_STATUS_VALID"] = 2] = "VALID_NUMBER_STATUS_VALID";
})(ValidNumberStatus_index || (ValidNumberStatus_index = {}));
export const SMSNumberService = {
    /**
     * GetValidity checks if the provided phone number is a valid, textable number.
     */
    GetValidity(fn, req) {
        return fn(`/sms/number/v1/validity?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * SetValidity updates Weave's records with a phone number's determined validity.
     */
    SetValidity(fn, req) {
        return fn(`/sms/number/v1/validity`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
